function initAdvancedBanner(advancedBanner: HTMLElement): void {
  const ctaRef = advancedBanner.querySelector('.cmp-advancedbanner__cta > a');
  const specialCharactersRegex = /[^a-zA-Z0-9_-]/;
  if (ctaRef) {
    const uri = (ctaRef as HTMLElement).getAttribute('href');
    const uriSegments = uri?.split('/') ?? [];
    const lastSegment = uriSegments[uriSegments.length - 1];
    if (
      uri?.startsWith('/content') &&
      !lastSegment.includes('.') &&
      !RegExp(specialCharactersRegex).exec(lastSegment)
    ) {
      ctaRef.setAttribute('href', uri + '.html');
    }
  }

  const backgroundImageUrl = advancedBanner?.getAttribute('data-backgroundimage');
  const backgroundColor = advancedBanner?.getAttribute('data-backgroundcolor');
  const gradientOpacityStart = advancedBanner?.getAttribute('data-gradient-opacity-start');
  const gradientOpacityEnd = advancedBanner?.getAttribute('data-gradient-opacity-end');
  const isSmartCropForBackground = advancedBanner?.hasAttribute('data-smart-crop-for-background');

  if (backgroundImageUrl && !backgroundColor && !isSmartCropForBackground) {
    advancedBanner.style.backgroundImage = `url('${backgroundImageUrl}')`;
  }
  if (backgroundColor && !backgroundImageUrl) {
    advancedBanner.style.backgroundColor = backgroundColor;
  }
  if (gradientOpacityStart) {
    advancedBanner.style.setProperty(
      '--gradient-opacity-start',
      (parseInt(gradientOpacityStart, 10) / 100).toString()
    );
  }
  if (gradientOpacityEnd) {
    advancedBanner.style.setProperty(
      '--gradient-opacity-end',
      (parseInt(gradientOpacityEnd, 10) / 100).toString()
    );
  }
}

export function advancedBannerReady(): void {
  const advancedBanners: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.cmp-advancedbanner__content'
  );

  advancedBanners.forEach((advancedBanner) => {
    initAdvancedBanner(advancedBanner);
  });
}

// Watches for Advanced Banners added to the DOM after initial load (e.g. Experience Fragments)
function observeAdvancedBanners(): void {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          if (node.matches('.cmp-advancedbanner__content')) {
            initAdvancedBanner(node);
          }
          node.querySelectorAll<HTMLElement>('.cmp-advancedbanner__content').forEach((banner) => {
            initAdvancedBanner(banner);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState !== 'loading') {
  advancedBannerReady();
  observeAdvancedBanners();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    advancedBannerReady();
    observeAdvancedBanners();
  });
}
